export const gradeOptions = Array.from({ length: 9 }, (_, index) => {
  const grade = index + 1;
  const suffix = grade === 1 ? 'st' : grade === 2 ? 'nd' : grade === 3 ? 'rd' : 'th';

  return {
    value: `${grade}${suffix}`,
    label: `${grade}${suffix} Grade`,
    enabled: grade === 7
  };
});

export const diagnosticQuestions = [
  {
    id: 'math-equation',
    subject: 'Math',
    question: 'Which value of x makes 4x + 3 = 19 true?',
    options: ['x = 2', 'x = 4', 'x = 5', 'x = 8']
  },
  {
    id: 'math-graph',
    subject: 'Math',
    question: 'What does the point (2, 5) tell you on a coordinate graph?',
    options: [
      'Move 2 right and 5 up',
      'Move 5 right and 2 up',
      'Move 2 left and 5 down',
      'The graph has a slope of 5'
    ]
  },
  {
    id: 'science-rocks',
    subject: 'Science',
    question: 'What can happen when rock is exposed to heat and pressure?',
    options: [
      'It can become metamorphic rock',
      'It always becomes sediment',
      'It disappears completely',
      'It immediately becomes soil'
    ]
  },
  {
    id: 'science-motion',
    subject: 'Science',
    question: 'Why does a rolling ball eventually slow down on the floor?',
    options: [
      'Friction changes its motion',
      'Gravity stops working',
      'The ball loses its mass',
      'The floor moves backward'
    ]
  }
];

export const placementRationale =
  'The responses suggest beginning with the next open lesson in each subject, while keeping completed work recognized.';